import { AggregationColor } from './color';
export const generateColor = (color) => {
    if (color instanceof AggregationColor) {
        return color;
    }
    return new AggregationColor(color);
};
export const getRoundNumber = (value) => Math.round(Number(value || 0));
export const getColorAlpha = (color) => getRoundNumber(color.toHsb().a * 100);
